export const SET_IS_PLAYING = 'IS_PLAYING';
export const GET_IS_PLAYING = 'GET_IS_PLAYING';
